module.exports = __webpack_public_path__ + "static/media/wall_bg1.a2781cc0.svg";